(function ($) {
    $(document).ready(function () {
        $('.password-field').each(function () {
            var $wrapper = $(this);
            var $input = $wrapper.find('input[type="password"], input[type="text"]');
            var $toggle = $wrapper.find('.toggle-password');

            $toggle.on('click', function () {
                if ($input.attr('type') === 'password') {
                    $input.attr('type', 'text');
                    $toggle.addClass('visible');
                } else {
                    $input.attr('type', 'password');
                    $toggle.removeClass('visible');
                }
            });
        });
    });
})(jQuery);
